<template>
  <div class="container-card">
    <div class="card-header-painel">
        <p class="titulo-card">Total de APR's</p>
    </div>
    <div class="card-conteudo">
        <div class="card-apr">
            <p class="quantidade-apr">{{dataQuatitativos.apr}}</p>
            <p class="informativo">APR's</p>
        </div>
        <div class="card-apr-pendentes">
            <p class="quantidade-apr">{{dataQuatitativos.aprPendetes}}</p>
            <p class="informativo">APR's Pendentes</p>
        </div>
    </div>
  </div>
</template>

<script>
import aprPainelReport from './aprPainelReport'
export default aprPainelReport
</script>

  <style scoped>
  .card-apr {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 50%;
    border-right: 1px solid #C9C9C9;
  }
  .card-apr-pendentes {
    width: 50%;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .informativo {
    font: normal normal 11px/33px Segoe UI;
    color: #656565;
    height: 0.6rem;
  }
  .quantidade-apr {
    font: normal normal 600 25px/33px Segoe UI;
    color: #008148;
    height: 0.6rem;
  }
  .titulo-card {
    font: normal normal 600 16px/33px Segoe UI;
    color: #008148;
  }
  .card-conteudo {
    display: flex;
    height: fit-content;
    width: 100%;
    padding: 0.5rem;
    background-color: white;
    border-radius: 0 0 10px 10px;

  }
  .card-header-painel {
    background-color: #F7F7F7;
    height: 2.5rem;
    width: 100%;
    border-radius: 10px 10px 0 0;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #C9C9C9;
  }
  .container-card {
    border-radius: 10px;
    height: fit-content;
    width: 100%;
    border: 1px solid #C9C9C9;
    margin-bottom: 1rem;
  }
  </style>



// WEBPACK FOOTER //
// src/views/private/apr/aprReport/components/aprReportTable/components/aprPainelReport/aprPainelReport.vue